import { ClickToCopyRemotePromoIdsDisplay } from "@/components/click_to_copy_remote_promo_id.tsx"
import { OpenPromotionLink } from "@/components/open_promotion_link.tsx"

interface PromotionDisplayProps {
  /** When set, an "Open promotion" link to the promotions page is shown. */
  promotion_id?: string
  promotion_name?: string
  promotion_remote_id?: string
  promotion_remote_ids?: string
  className?: string
}

export function PromotionDisplay({ 
  promotion_id,
  promotion_name, 
  promotion_remote_id, 
  promotion_remote_ids,
  className 
}: PromotionDisplayProps) {
  // Determine which remote ID(s) to display
  // Prefer promotion_remote_ids (comma-separated) if available, otherwise use promotion_remote_id (single)
  const remoteIds = promotion_remote_ids || promotion_remote_id

  // Don't render if no promotion data is available
  if (!promotion_name && !remoteIds) {
    return null
  }

  return (
    <div class={className}>
      <div class="flex items-center justify-between gap-2 mb-1">
        <div class="text-gray-500 text-sm">Matched Promotion</div>
        {promotion_id && <OpenPromotionLink promotion_id={promotion_id} />}
      </div>
      {promotion_name && (
        <div class="text-sm text-gray-900 font-medium">{promotion_name}</div>
      )}
      {remoteIds && (
        <div class="text-xs text-gray-500 mt-1">
          <span class="text-gray-500">ID: </span>
          <ClickToCopyRemotePromoIdsDisplay value={remoteIds} />
        </div>
      )}
    </div>
  )
}


